require('./brokerBenefitsSimulatorView.scss');

// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');

// @components
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');

// @helpers
const { formatText, getLanguage } = require('core/i18n').i18n;

// @constants
const {
    MYPROFILE_BROKER_URL
} = require('constants/index');
const EN_LANGUAGE = 'EN';
const AFI_ISO_LANGUAGE_EN = 'en-US';
const AFI_ISO_LANGUAGE_ES = 'es-ES';
const { SIMULATOR_PENSION_PLAN_BENEFITS } = require('constants/tagging');

// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class BrokerBenefitsSimulatorView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        scrollToTop();
        if (__CONTACT_CENTER__) {
            window.addEventListener('beforeunload', function (e) {
                this.props.history.push(MYPROFILE_BROKER_URL);
                e.preventDefault();
                e.returnValue = '';
            });
        }
        window && window.utag && window.utag.view && window.utag.view({ nombrePagina: SIMULATOR_PENSION_PLAN_BENEFITS })
    }

    componentWillUnmount() {
        if (__CONTACT_CENTER__) {
            window.removeEventListener('beforeunload');
        }
    }

    render() {
        const BREADCRUMB = [
            {
                text: formatText('futures-investments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('futures-products'),
                url: ''
            },
            {
                text: formatText('plans-benefitsSimulator'),
                url: ''
            }
        ];

        const host = window.location.origin;
        const endpoint = MYPROFILE_BROKER_URL;
        const language = getLanguage().toUpperCase() === EN_LANGUAGE ? AFI_ISO_LANGUAGE_EN : AFI_ISO_LANGUAGE_ES;

        return (
            <div className="broker-benefits-simulator-view">
                <OKCover size="medium" section="broker">
                    <BrokerTruncatedBreadcrumb
                        titleKey="plans-benefitsSimulator"
                        breadcrumbConfig={BREADCRUMB}
                    />
                </OKCover>
                <section className="broker-benefits-simulator-view__body">
                    <ContentBox>
                        <div className="broker-benefits-simulator-view__section">
                            <iframe
                                frameBorder="0"
                                height="800"
                                scrolling="yes"
                                src={`https://simuladores.afi.es/simulatorsjs/openbank/benefitplansimulator.aspx?url=${host}${endpoint}&lang=${language}`}
                                title="Simulador de Prestaciones"
                                width="100%"
                            >
                            </iframe>
                        </div>
                    </ContentBox>
                </section>
            </div>
        );
    }
}

BrokerBenefitsSimulatorView.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports.constructor = BrokerBenefitsSimulatorView;
module.exports.BrokerBenefitsSimulatorView = connect()(withRouter(BrokerBenefitsSimulatorView));
